// extracted by mini-css-extract-plugin
export default {"wrapper":"MicrogridTopologyModeling_wrapper__Eflsb","content":"MicrogridTopologyModeling_content__0uBgp"};